// extracted by extract-css-chunks-webpack-plugin
module.exports = {"avatar_dropzone":"AvatarField__avatar_dropzone--1zMsb","upload":"AvatarField__upload--PEOVP"};